import { Checkbox, Select } from '@watcherr/ui';
import * as React from 'react';
import { t } from '~/i18n';
import { useSite } from '~/hooks/site';
import GeofenceSettings from '../components/GeofenceSettings';
import { useZones } from '~/hooks/zone';


interface GeofenceSettingsContainerProps {
  siteUuid: string;
  show: boolean;
  selectedPlane?: string;
  selectedZones: string[];
  onPlaneChange: (plane: string) => void;
  onZoneSelectChange: (zones: string[]) => void;
}

const GeofenceSettingsContainer: React.FC<GeofenceSettingsContainerProps> = ({
  siteUuid,
  show,
  selectedPlane,
  onPlaneChange,
  selectedZones,
  onZoneSelectChange,
}) => {


  const site = useSite(siteUuid);
  const planeOptions = React.useMemo(
    () =>
      site ? site.planes.map((p) => ({ value: p.uuid, label: p.name })) : [],
    [site]
  );
  const zones = useZones({ planeUuid: selectedPlane, siteUuid: siteUuid });

  const [isSelectAll, setIsSelectAll] = React.useState<boolean>();

  const handleSelect = React.useCallback(
    (zoneUuid) => (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.currentTarget.checked) {
        if (!selectedZones.includes(zoneUuid)) {
          onZoneSelectChange([...selectedZones, zoneUuid]);
        }
      } else {
        onZoneSelectChange([...selectedZones.filter((z) => z !== zoneUuid)]);
      }
    },
    [selectedZones]
  );

  const handleSelectAll = () => {
    if (isSelectAll) {
      onZoneSelectChange(selectedZones.filter(zone => !zones.map(zone => zone.uuid).includes(zone))); // Deselect all
    } else {
      onZoneSelectChange([...selectedZones, ...zones.map((zone) => zone.uuid)]); // Select all
    }
    setIsSelectAll(!isSelectAll);
  };


  const checkIfSelected = () => {
    let selectedLength = 0
    zones.map((zone) => {
      if(selectedZones.find((item) => item === zone.uuid)){
        selectedLength ++
      }
      }
    )
    setIsSelectAll(selectedLength == zones.length ? true : false)
  }

  React.useEffect(() => {
    checkIfSelected()
  }, [zones]);


  return (
    <GeofenceSettings show={show}>
      <div className="mb-15" style={{ flex: 0 }}>
        <Select
          label={t('geofence.settings.selectLevel')}
          value={selectedPlane}
          as="filter"
          options={planeOptions}
          onChange={onPlaneChange}
        />
      </div>
      {!!zones.length && (
        <div style={{ flex: 1, overflow: "scroll" }}>
          <h5>{t('geofence.settings.selectZones')}</h5>
          <h6 onClick={handleSelectAll}>{isSelectAll ? `${t('geofence.settings.deselectAllZones')}` : `${t('geofence.settings.selectAllZones')}`}</h6>
          {zones.map((zone) => (
            <Checkbox
              id={`zone-select-${zone.uuid}`}
              key={`zone-select-${zone.uuid}`}
              label={zone.name}
              onChange={handleSelect(zone.uuid)}
              checked={selectedZones.includes(zone.uuid)}
            />
          ))}
        </div>
      )}
    </GeofenceSettings>
  );
};

export default GeofenceSettingsContainer;
